<template>
	<div v-if="commenterUser" class="comment-container flex-align-start display-flex flex-row" :class="{ active: menuOpen }">
		<AppTooltip :position="'top'" :text="commenterUser.name">
			<SettingsManageUsersInfoAvatar initials :user="commenterUser" :size="25" />
		</AppTooltip>
		<div class="ml-2 display-flex flex-column">
			<div class="display-flex flex-row flex-align-center">
				<div class="content-container display-flex flex-column">
					<div class="commenter bold">{{ commenterUser.name }}</div>
					<div class="comment">{{ content }}</div>
				</div>
				<div @click="toggleLike" role="button">
					<SIcon class="heart" :name="`idea-comment-${didCurrentUserLike ? 'full' : 'empty'}-heart`" width="12" height="14" />
				</div>
				<div v-if="numOfLikes" class="likes ml-1">{{ numOfLikes }}</div>
				<AppDropdownMenu
					right
					bottom
					absolute
					min-width="215"
					:nudge-bottom="10"
					:items="optionsItems"
					v-if="isCurrentUserTheCommenter"
					v-model="menuOpen"
				>
					<template #activator="{ on }">
						<v-btn class="menu-activator ml-2" v-on="on" icon small rounded width="20" height="20">
							<SIcon class="menu-button" name="menu-button" width="20" />
						</v-btn>
					</template>
				</AppDropdownMenu>
			</div>
			<timeago class="time-ago" :datetime="lastTimeStamp" :auto-update="10" />
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import { getAccountMembers } from '@/store/modules/account/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar';
import { likeIdeaComment, unlikeIdeaComment, removeIdeaComment } from '@/store/modules/inspirationCenter/actions';
export default {
	name: 'IdeaComment',
	components: { SettingsManageUsersInfoAvatar },
	props: {
		comment: { type: Object },
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ teamMemberByUserId }),
		content() {
			return this.comment.content;
		},
		commenterUserId() {
			return this.comment.commenter;
		},
		commenterUser() {
			return this.teamMemberByUserId(this.commenterUserId);
		},
		lastTimeStamp() {
			return this.comment.updated_at || this.comment.created_at;
		},
		numOfLikes() {
			return this.comment.likers.length;
		},

		optionsItems() {
			return [
				// { text: 'Edit', onClick: this.edit },
				{ text: 'Delete', onClick: this.delete },
			];
		},
		currentUserId() {
			return this.user.id;
		},
		isCurrentUserTheCommenter() {
			return this.currentUserId === this.comment.commenter;
		},
		didCurrentUserLike() {
			return this.comment.likers.includes(this.currentUserId);
		},
	},
	methods: {
		...mapActionsShorthand({ getAccountMembers, likeIdeaComment, unlikeIdeaComment, removeIdeaComment }),
		edit() {
			console.log('EDIT');
		},
		delete() {
			this.removeIdeaComment({
				commentId: this.comment.id,
				ideaId: this.comment.idea,
			});
		},
		async toggleLike() {
			if (this.loading) {
				return;
			}
			this.loading = true;
			await (this.didCurrentUserLike ? this.unlikeIdeaComment : this.likeIdeaComment)({
				commentId: this.comment.id,
				ideaId: this.comment.idea,
			});
			this.loading = false;
		},
	},
	async mounted() {
		await this.getAccountMembers();
	},
	data() {
		return { loading: false, menuOpen: false };
	},
};
</script>

<style scoped lang="scss">
.comment-container {
	.menu-activator {
		display: none;
	}
	&:hover,
	&.active {
		.menu-activator {
			display: inline-flex;
		}
	}
}
.content-container {
	padding: 5px 11px;
	border-radius: 9px;
	background: #f7f7f9;
}
.commenter {
	font-size: 10px;
	letter-spacing: 0px;
	color: #292829;
}
.comment {
	font-size: 14px;
	color: #292829;
}
.time-ago {
	font-size: 9px;
	color: #292829;
	font-style: italic;
}
.heart {
	cursor: pointer;
	margin-left: 6px;
}
.likes {
	color: #292829;
	font-size: 11px;
}
</style>
